import { createSelector } from '@ngrx/store';

import { BusesResultsModuleState } from '@buses/bus-results/store/state/bus-results-module.state';
import { busResultsRootSelector } from './bus-results-root.selector';

export const getUiBusesState = createSelector(
  busResultsRootSelector,
  (state: BusesResultsModuleState) => state.ui
);

